module.exports = global["$"] = require("-!C:\\wamp64\\www\\mmv2023\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 501
// module chunks = 1